module.exports = __webpack_public_path__ + "assets/img/eventDriven.4aea1744.png";